import { useCallback, useEffect, useState } from 'react'

import { Button, Card, Grid, Input, Row } from 'components'
import { ArrowLeftIcon, ArrowRigthIcon } from 'components/Icons'
import { useAuth, useLoading } from 'hooks'
import { useHistory } from 'react-router'
import { useLocation } from 'react-router-dom'
import {
  UserContractServices,
  UserSupplierServices
} from 'services/Supplier/Users'
import { COLORS, SPACING } from 'utils'
//import { createArrayCopy } from "utils/functions"
import { isEqual } from 'utils/functions'
import { ContratoFornecedor, UsuarioFornecedor } from 'utils/types'

import { CardContracts } from './components'
import { IconsContainer } from './components/CardContracts/styles'
import { PERMITIONS } from 'permitions'

export interface IListaContratos {
  selected: boolean
  content: ContratoFornecedor
}

export interface UsuarioStateProps {
  idUsuarioFornecedor: string
  isValidateAcess: boolean
}

const CollaboratorContract = () => {
  const { setLoading, setMsgErro, toggleSucessShow, setMsgSucesso } =
    useLoading()
  const { state } = useLocation<UsuarioStateProps>()
  const { goBack } = useHistory()
  const { user } = useAuth()

  const [userSelected, setUserSelected] = useState<
    UsuarioFornecedor | undefined
  >()
  const [listContract, setListContract] = useState<
    IListaContratos[] | undefined
  >()
  const [initialListContract, setInitialListContract] = useState<
    IListaContratos[] | undefined
  >()
  const [listAprovedContract, setListAprovedContract] = useState<
    IListaContratos[] | undefined
  >()
  const [initialListAprovedContract, setInitialListAprovedContract] = useState<
    IListaContratos[] | undefined
  >()

  const handleSelectCardRight = (index: number) => {
    if (listAprovedContract[index].selected == true) {
      listAprovedContract[index].selected = false
    } else {
      listAprovedContract[index].selected = true
    }
    setListAprovedContract([...listAprovedContract])
  }

  const handleSelectCardLeft = (index: number) => {
    if (listContract[index].selected == true) {
      listContract[index].selected = false
    } else {
      listContract[index].selected = true
    }

    setListContract([...listContract])
  }

  const transferContractsLeftCard = () => {
    listAprovedContract.map((contract) => {
      if (contract.selected) {
        setListContract((listContract) => [
          ...listContract,
          { content: contract.content, selected: false }
        ])
      }
    })
    setListAprovedContract([
      ...listAprovedContract.filter((contract) => !contract.selected)
    ])
  }

  const transferContractsRightCard = () => {
    listContract.map((contract) => {
      if (contract.selected) {
        setListAprovedContract((listAprovedContract) => [
          ...listAprovedContract,
          { content: contract.content, selected: false }
        ])
      }
    })
    setListContract([...listContract.filter((contract) => !contract.selected)])
  }

  const getUsuarioFornecedor = useCallback(async () => {
    setLoading('loading')
    try {
      const response = await UserSupplierServices().get(
        parseInt(state.idUsuarioFornecedor)
      )

      if (response.status !== 200)
        throw new Error('Erro obter dados do usuario. Tente novamente.')
      setUserSelected(response.data)
    } catch (error: any) {
      setMsgErro(error.toString())
      setLoading('error')
      goBack()
    }
  }, [state])

  useEffect(() => {
    getUsuarioFornecedor()
  }, [getUsuarioFornecedor])

  useEffect(() => {
    const getData = async () => {
      setLoading('loading')

      //DIREITA
      const getUserContracts = new Promise((res, rej) =>
        UserContractServices()
          .getContratosUsuario(
            // @:TROCA userSelected.fornecedorId,
            userSelected.usuario.idUsuario,
            true,
            userSelected.usuarioId
          )
          .then(({ data }) => res(data))
          .catch((err) => rej(err))
      )

      //ESQUERDA
      const getAllContracts = new Promise((res, rej) =>
        UserContractServices()
          .getContratosUsuario(
            //@:TROCA userSelected.fornecedorId,
            userSelected.usuario.idUsuario,
            false,
            state?.isValidateAcess ? userSelected?.usuarioIdAdministrador && userSelected?.usuarioIdAdministrador > 0 ? userSelected?.usuarioIdAdministrador : userSelected.usuario.idUsuario : user.IdUsuario
          )
          .then(({ data }) => res(data))
          .catch((err) => rej(err))
      )

      try {
        const response = await Promise.allSettled([
          getUserContracts,
          getAllContracts
        ])

        response.forEach((el) => {
          if (el.status === 'rejected') {
            throw new Error(el.reason.data || 'Erro obter dados.')
          }
        })
        let contracts = []
        let userContracts = []

        if (response[0].status === 'fulfilled') {
          userContracts = response[0].value as []
        }

        if (response[1].status === 'fulfilled') {
          contracts = response[1].value as []
        }

        const newListContracts = contracts.map((el) => ({
          content: el,
          selected: false
        }))

        const newListUserContracts = userContracts.map((el) => ({
          content: el,
          selected: false
        }))

        setListContract(newListContracts)
        setListAprovedContract(newListUserContracts)
        setInitialListContract(newListContracts)
        setInitialListAprovedContract(newListUserContracts)

        setLoading('idle')
      } catch (error: any) {
        setMsgErro(error.message || 'Erro obter contratos.')
        setLoading('error')
      }
    }
    userSelected != undefined && getData()
  }, [userSelected])

  const differenceResult = (firstArray, secondArray) => {
    return firstArray.filter(
      (firstArrayItem) =>
        !secondArray.some(
          (secondArrayItem) =>
            firstArrayItem.content.idContrato ===
            secondArrayItem.content.idContrato
        )
    )
  }

  const handleSalvarContratos = async () => {
    setLoading('loading')

    const listNewContract = differenceResult(
      listAprovedContract,
      initialListAprovedContract
    )

    const listDeletedContract = differenceResult(
      initialListAprovedContract,
      listAprovedContract
    )

    try {
      let responseDelete
      let responseCreate

      const objEnvioAprovados = listNewContract.map((el) => ({
        idContrato: el.content.idContrato,
        idContratoUsuFornecedor: 0,
        idUsuario: userSelected.usuarioId
      }))

      const objEnvioReprovados = listDeletedContract.map(
        (el) => el.content.idContratoUsuFornecedor
      )

      if (objEnvioAprovados.length > 0) {
        responseCreate = await UserContractServices().create(objEnvioAprovados)
      }

      if (objEnvioReprovados.length > 0) {
        responseDelete = await UserContractServices().del(objEnvioReprovados)
      }

      if (responseCreate?.data?.sucesso || responseDelete?.data?.sucesso) {
        setMsgSucesso('Sucesso ao salvar vinculos de contrato e usuario')
        toggleSucessShow()
        setLoading('idle')
        getUsuarioFornecedor()
        return
      }

      if (objEnvioAprovados.length > 0 || objEnvioReprovados.length > 0) {
        throw new Error('Erro ao salvar vinculos de contrato')
      }
      setLoading('idle')
    } catch (error) {
      setMsgErro(error.toString())
      setLoading('error')
    }
  }

  const isContractsAdmin = useCallback((): boolean => {
    const isAdmin = true
    const isNotAdmin = false

    if (user.PerfilUsuarioId === PERMITIONS.FORNECEDORADMINISTRADOR) {
      return isAdmin
    }

    if (
      listAprovedContract?.some((contract) => contract.content.flIsAdmin) ||
      listContract?.some((contract) => contract.content.flIsAdmin)
    ) {
      return isAdmin
    }

    return isNotAdmin
  }, [listAprovedContract, listContract])

  const disableSaveButton = useCallback((): boolean => {
    const enableButton = false
    const disableButton = true

    if (
      isEqual(
        listAprovedContract?.map((x) => x.content),
        initialListAprovedContract?.map((x) => x.content)
      )
    ) {
      return disableButton
    }

    if (
      isEqual(
        listContract?.map((x) => x.content),
        initialListContract?.map((x) => x.content)
      )
    ) {
      return disableButton
    }

    if (!isContractsAdmin()) {
      return disableButton
    }

    return enableButton
  }, [listAprovedContract, listContract])

  return (
    <Card
      marginLeft={SPACING.spacing20}
      marginRight={SPACING.spacing20}
      marginTop={SPACING.spacing20}
      marginBottom={SPACING.spacing75}
      padding={SPACING.spacing20}
      boxShadow={`0 0 1em ${COLORS.lightGray}`}
    >
      <Grid
        gridCols="1fr 2.5fr 2fr 2.5fr"
        gridGap={`${SPACING.spacing5}`}
        margin={`${SPACING.spacing10} 0 ${SPACING.spacing10} 0`}
      >
        <Input
          label="CPF/Passaporte"
          disabled
          value={userSelected?.usuario?.cdDocto?.toUpperCase()}
          mask={
            isNaN(parseInt(userSelected?.usuario?.cdDocto))
              ? ['NN##########']
              : ['###.###.###-##']
          }
        />
        <Input
          label="Colaborador"
          disabled
          marginLeft={SPACING.spacing20}
          value={userSelected?.usuario?.nmUsuario}
        />
        <Input
          label="E-mail"
          disabled
          marginLeft={SPACING.spacing20}
          marginRight={SPACING.spacing20}
          value={userSelected?.usuario?.txEmail}
        />
      </Grid>

      <div
        style={{
          ...(!isContractsAdmin() && {
            opacity: 0.7,
            pointerEvents: 'none'
          })
        }}
      >
        <Grid gridCols="1fr 10rem 1fr" margin="3rem 0">
          <CardContracts
            list={listContract}
            onClick={handleSelectCardLeft}
            title="Contratos não vinculados"
          />
          <IconsContainer style={{ marginTop: '2rem' }}>
            <ArrowRigthIcon
              marginBottom={SPACING.spacing50}
              colorIcon={COLORS.blueFonts}
              onClick={transferContractsRightCard}
            />
            <ArrowLeftIcon
              colorIcon={COLORS.blueFonts}
              onClick={transferContractsLeftCard}
            />
          </IconsContainer>
          <CardContracts
            list={listAprovedContract}
            onClick={handleSelectCardRight}
            title="Contratos vinculados"
          />
        </Grid>
      </div>
      <Row justifyContent="flex-end" alignItems="center">
        <Button
          text="Voltar"
          variantButton="outlined"
          backgroundColor={COLORS.white}
          textColor={COLORS.black}
          borderColor={COLORS.black}
          onClick={goBack}
        />
        <Button
          text="Salvar"
          onClick={handleSalvarContratos}
          disabled={disableSaveButton()}
          marginLeft={SPACING.spacing20}
        />
      </Row>
    </Card>
  )
}

export default CollaboratorContract
